























































import { parse } from "date-fns";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { Match } from "@/types";
import TimelineData from "@/components/timeline/TimelineData.vue";
import TimelineSlider from "@/components/timeline/TimelineSlider.vue";
import { State } from "vuex-class";
import DocumentSummary from "@/components/DocumentSummary.vue";

@Component({
  components: { DocumentSummary, TimelineData, TimelineSlider }
})
export default class TimelineContainer extends Vue {
  private types: [string, string][] = [
    ["1", "Conditions & Symptoms"],
    ["7", "Procedures"],
    ["4", "Labs & Vitals"],
    ["6", "Medications"],
    ["15", "Misc"]
  ];

  @State("text")
  private document!: string;

  private selectedTypes: string[] = ["1", "7", "4", "6", "15"];

  @Prop({ default: () => [] })
  private matches!: Match[];

  private xScale: any = null;

  private yScale: any = null;

  private range: [Date, Date] | null = null;

  get matchesWithDates() {
    return this.matches.filter(
      match =>
        match.refers &&
        match.refers.date &&
        /\d{1,4}-\d{1,2}-\d{1,2}/.test(match.refers.date.concept.text.phrase)
    );
  }

  get records() {
    return this.matchesWithDates
      .filter(match => this.selectedTypes.includes(match.concept.concepttype))
      .map(match => ({
        date: new Date(
          parse(match.refers.date.concept.text.phrase, "y-M-d", new Date())
        ),
        name: match.concept.conceptname.replace(/_/g, " "),
        raw: match,
        context: match.context
      }));
  }
}
